import { render, staticRenderFns } from "./StudentEnglishScoreList.vue?vue&type=template&id=a582ce5a&"
import script from "./StudentEnglishScoreList.vue?vue&type=script&lang=ts&"
export * from "./StudentEnglishScoreList.vue?vue&type=script&lang=ts&"
import style0 from "./StudentEnglishScoreList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports